/**
 * Some additions to the contact lookup, specifically for gravity forms.
 */

document.addEventListener('DOMContentLoaded', () => {

        const clearLookupFieldErrorMessages = event => {
            const $lookupField = event?.detail?.formData?._$lookupField?._agendUpbeatContactLookupField?._$container;

            if (!$lookupField) {
                return;
            }

            $lookupField.querySelectorAll('.validation_message').forEach($el => $el.remove());
        }

        // Listen for contact lookup events, and remove the lookup field error message, if there is one
        // present, when the lookup wants to display messages/etc.
        [
            'agend.contact-lookup.contact-not-found',
            'agend.contact-lookup.contact-found',
            'agend.contact-lookup.error',
        ].forEach(eventName => document.addEventListener(eventName, clearLookupFieldErrorMessages));
    }
);
